import encoding from 'encoding'

const CHARSET = 'ISO-8859-1'

const getFileContent = rows => {
  let csvContent = ''
  rows.forEach((element, index) => {
    const keys = Object.keys(element)
    const values = keys.map(key => removeNewLine(element[key]))
    if (index === 0) {
      const headerRow = keys.join(';')
      csvContent += headerRow + '\n'
    }
    const valueRow = values.join(';')
    csvContent += index < rows.length ? valueRow + '\n' : valueRow
  })
  return toIso8859(csvContent)
}

const NL_DELIMITER = '   '

const removeNewLine = value =>
  typeof value === 'string'
    ? `"${value
        .replaceAll('\r\n', NL_DELIMITER)
        .replaceAll('\n', NL_DELIMITER)
        .replaceAll('"', "'")}"`
    : `"${value !== null && value !== undefined ? value : ''}"`

// The download function takes a CSV string, the filename and mimeType as parameters
// Scroll/look down at the bottom of this snippet to see how download is called
const download = function (rows, fileName, mimeType) {
  const content = getFileContent(rows)
  const a = document.createElement('a')
  mimeType = mimeType || 'application/octet-stream'

  if (navigator.msSaveBlob) {
    // IE10
    navigator.msSaveBlob(
      new Blob([content], {
        type: mimeType,
      }),
      fileName
    )
  } else if (URL && 'download' in a) {
    //html5 A[download]
    a.href = URL.createObjectURL(
      new Blob([content], {
        type: mimeType,
      })
    )
    a.setAttribute('download', fileName)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  } else {
    window.location.href = 'data:application/octet-stream,' + encodeURIComponent(content) // only this mime type is supported
  }
}

export const csvExport = (rows, filename = 'export.csv') =>
  download(rows, filename, `text/csv;encoding:${CHARSET}`)

export const toIso8859 = text => encoding.convert(text, CHARSET)
